/**
 * Tag-search MainListing stacks modules with `noWrapper`. Hide a module when the
 * list query has finished with no rows (errors still render via LoaderErrorWrapper).
 */
export function hideTagsSearchListingSection(
  noWrapper: boolean,
  loading: boolean,
  rowCount: number,
  dataLength: number,
  error?: unknown,
): boolean {
  if (!noWrapper) return false;
  if (loading) return false;
  if (error) return false;
  return (rowCount ?? 0) === 0 && (dataLength ?? 0) === 0;
}
